import { Property } from "./interfaces";

export const cantidadOS: Property = {
    title: "Cantidad de OS",
    type: "integer"
}